import http from '../../../utils/fetch';

export default {
    baseurl: '/api/swyl/v1/productlevel',
    //分页/检索
    query(query) {
        return http({
            url: this.baseurl + '/productLevel/selectPage',
            method: 'post',
            params:query
        });
    },
    //暂存产品层级
    zanCun(query) {
        return http({
            url: this.baseurl + '/productLevel/zanCun',
            method: 'post',
            params:query
        });
    },
    //提交
    submit(query){
        return http({
            url: this.baseurl + '/productLevel/submit',
            method: 'post',
            params:query
        });
    },
    //驳回
    plNo(query){
        return http({
            url: this.baseurl + '/productLevel/plNo',
            method: 'post',
            params:query
        });
    },
    //通过
    plPass(query){
        return http({
            url: this.baseurl + '/productLevel/plPass',
            method: 'post',
            params:query
        });
    },
    //审批展示
    selectByYwid(query){
        return http({
            url: this.baseurl + '/productLevel/selectByYwid',
            method: 'post',
            params:query
        });
    },
    //编辑页单条
    selectByPid(query){
        return http({
            url: this.baseurl + '/productLevel/selectByPid',
            method: 'post',
            params:query
        });
    },
    selectByFid(v){
        return http.post('/api/swyl/v1/productlevel/productLevel/selectByFid?fid='+v);
    },
    selectTwo(v){
        return http.post('/api/swyl/v1/productlevel/productLevel/showprocategory?id='+ v);
    },
    deleteById(v){
        return http.post('/api/swyl/v1/productlevel/productLevel/deleteById?id='+v);
    },
    deleteByIdDraft(v){
        return http.post('/api/swyl/v1/productlevel/productLevel/deleteByIdDraft?id='+v);
    },
    updateById(query){
        return http({
            url: this.baseurl + '/productLevel/updateById',
            method: 'post',
            params:query
        });
    },

    selectLevelByModel(v){
        return http.post('/api/swyl/v1/productlevel/productLevel/selectLevelByModel?promodel='+v);

    },

    selectModelByLevel(v){
        return http({
            url: '/api/swyl/v1/productlevel/productLevel/selectModelByLevel',
            method: 'post',
            params:v
        });
    }


}
